import React, { Component } from 'react';
import { connect } from 'react-redux';
import { compose } from 'redux';
import { Field, reduxForm, getFormValues } from 'redux-form';
import { withRouter } from 'react-router-dom';
import Loader from 'react-loader';
import { Button } from 'reactstrap';

import { updateHomepageData, fetchHomepageData } from './actions';
import { getSelectedLanguage, getData, isLoaded, getError } from './selectors';
import TextField from '../../components/common/TextField';
import { HP_SETTINGS_FORM_NAME } from './constants';

const required = value => (value ? undefined : 'Povinný údaj');

class HomepageSettings extends Component {

  componentWillUnmount() {
    console.log('unmount');
  }

  onSubmit = formProps => {
    const { lang, updateHomepageData } = this.props;
    delete formProps.id;
    delete formProps.created;
    delete formProps.updated;
    delete formProps.image;


    const data = {};

    Object.entries(formProps).forEach(([key, value]) => {
      data[key] = value;
    });

    updateHomepageData(data, lang);
  };

  render() {
    const { handleSubmit, isLoaded, lang, initialValues } = this.props;

    if (lang === '') {
      return <div />;
    }

    return (
      <div className="homepage-settings">
        <Loader loaded={isLoaded}>
          {initialValues && (
            <form onSubmit={handleSubmit(this.onSubmit)}>
              <Field
                component={TextField}
                type="text"
                label="Hlavní nadpis"
                name="header"
                validate={required}
              />
              <Field
                component={TextField}
                type="textarea"
                label="Podnadpis"
                name="subtitle"
                validate={required}
              />
              <Field
                component={TextField}
                type="text"
                label="Title"
                name="title"
                validate={required}
              />
              <Field
                component={TextField}
                type="textarea"
                label="Meta description"
                name="description"
                validate={required}
              />
              <div className="form-buttons">
                <Button color="primary">Uložit</Button>
                <Button color="danger" onClick={this.props.clearData}>
                  Zpět
                </Button>
              </div>
            </form>
          )}
        </Loader>
      </div>
    );
  }
}

const mapStatetoProps = state => {
  return {
    isLoaded: true,
    lang: getSelectedLanguage(state),
    initialValues: getFormValues(HP_SETTINGS_FORM_NAME)(state),
    error: getError(state)
  };
};

const mapDispatchToProps = {
  fetchHomepageData,
  updateHomepageData,
}

export default compose(
  withRouter,
  connect(
    mapStatetoProps,
    mapDispatchToProps,
  ),
  reduxForm({form: HP_SETTINGS_FORM_NAME }),
)(HomepageSettings)



// WEBPACK FOOTER //
// ./src/modules/HomepageSettings/index.js